/**
 * Validates that the redirect url is relative or has the same origin as the current url.
 * For info, origin contains protocol, domain and port of the url.
 *
 * @param {*} currentUrl
 * @param {*} redirectUrlString
 * @returns
 */
const validateRedirectUrl = (currentUrlString, redirectUrlString) => {
  const currentUrl = new URL(currentUrlString);
  const redirectUrl = new URL(redirectUrlString, currentUrl.origin); // If a relative url is sent, use the same origin as current url
  const IsSameOrigin = currentUrl.origin === redirectUrl.origin;
  if (!IsSameOrigin) {
    return false;
  }
  return true;
};

export default validateRedirectUrl;
